import { resetKeyboard } from '../cordovaPlugins/Keyboard';

export function Keyboard() {
  resetKeyboard();
}
